<template>
    <div class="v-add-to-cart ">
        <!-- <div> -->
        <div class="v-add-to-cart__text q-pr-md">Quantity</div>
        <div class="v-add-to-cart__counter">
            <q-icon @click="itemCount--" class="icon cursor-pointer q-py-sm q-ml-sm" name="remove" size="md" />
            <input type="number" v-model="itemCount" class="text-center input-number" />
            <q-icon @click="itemCount++" class="icon cursor-pointer q-py-sm q-pr-sm" name="add" size="md" />
        </div>
        <!-- </div>
            <div> -->
        <div class="btn-section"><q-btn @click="onAddToCart" class="btn-add-to-cart" label="ADD TO CART" /></div>
        <!-- </div> -->
    </div>
</template>
<script setup>
/* eslint-disable */
import { defineProps, defineEmits, ref, onMounted, computed, watch } from 'vue';
import { useCartStore } from '../../stores/cart-store';
import { useQuasar } from 'quasar'
const { addToCart } = useCartStore();

const emit = defineEmits(['onAddToCart'])
const itemCount = ref(1);

const props = defineProps({
    product: Object
})

const productData = computed(() => {
    return props.product;
})
watch(itemCount, newVal => {
    if (newVal < 1) {
        itemCount.value = 1
    }
})

// function onAddToCart() {
//     emit('onAddToCart', { quantity: itemCount.value });
// }
async function onAddToCart() {
    await addToCart(productData.value.id, itemCount.value);
}

</script>

<style lang="scss" scoped>
.v-add-to-cart {
    display: flex;
    align-items: center;
    border-top: 1px solid #e2e2e2;
    padding-top: 13px;

    &__text {
        font-weight: 700;
        font-size: 14px;
        line-height: 18px;
        text-align: center;
        letter-spacing: 0.5px;
        text-transform: uppercase;
        color: $primary;
    }

    &__counter {
        border: 1px solid #75767F;
        border-radius: 4px;

        .icon {
            color: $primary;
        }

        .input-number {
            border: unset;
            width: 73px;

            align-items: center;
            text-align: center;
            letter-spacing: 0.5px;
            color: #75767F;
            font-size: 16px;
            line-height: 22px;
        }
    }

    .btn-add-to-cart {
        background: #0684C7;
        border-radius: 8px;
        padding: 10px 16px;
        color: #fff;
        // width: 106px;
        // height: 40px;
    }
}

.btn-section {
    margin-left: auto;
}
</style>